// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusCell {
  font-size: 1em;
  font-weight: 700;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/DynamicReport/components/ReportTable/components/StatusCell/styles.scss"],"names":[],"mappings":"AAAA;EAGE,cAAA;EACA,gBAAA;EACA,mBAAA;AADF","sourcesContent":[".StatusCell {\n  // Match the surrounding report table cells rather than bootstrap's smaller,\n  // lighter badge text.\n  font-size: 1em;\n  font-weight: 700;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
